// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-date {
  margin-top: 15px;
}

mat-form-field {
  width: 100%;
  margin: 10px auto;
}

.lower-right-button {
  position: absolute;
  bottom: 0;
  right: 1%;
}

.separator {
  height: 15px;
}

.modal-content {
  padding: 15px;
}
.modal-content .div-see {
  overflow-y: auto;
}
.modal-content .div-see .card {
  width: 100%;
  margin: 10px auto;
}
.modal-content .div-see .card .id {
  color: rgb(173, 173, 173);
  font-style: italic;
}
.modal-content .non_inherited {
  color: #8bb7f0;
}

.wrapper {
  margin: 30px auto;
  margin-bottom: 50px;
  width: 100%;
  max-width: 120px;
  border-radius: 5px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 25px;
  position: relative;
}

.wrapper h3,
.wrapper p {
  font-family: "Neucha", cursive;
  padding: 10px;
  border-radius: 5px 0 0 5px;
  font-size: 18px;
  color: #333;
}

.plus {
  right: -20px;
  color: #538ae4;
}

.minus {
  cursor: pointer;
}

.group {
  position: relative;
  margin-bottom: 45px;
}

.sub-title {
  font-size: 1.5rem;
}

.bloc-document {
  border-radius: 5px;
  background-color: #e3e3e3;
  padding: 5px 10px;
  margin: 10px 0;
}

.bloc-documenthide {
  border-radius: 5px;
  background-color: #777777;
  padding: 5px 10px;
  margin: 10px 0;
}

::ng-deep .myTooltip .mdc-tooltip__surface {
  background: #ecac54 !important;
  font-size: 1rem !important;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/dialog-add-document-request/dialog-add-document-request.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,iBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EAEA,SAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;AAII;EACE,WAAA;EACA,iBAAA;AAFN;AAIM;EACE,yBAAA;EACA,kBAAA;AAFR;AAOE;EACE,cAAA;AALJ;;AASA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;AANF;;AASA;;EAEE,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;AANF;;AASA;EACE,YAAA;EACA,cAAA;AANF;;AASA;EACE,eAAA;AANF;;AAcA;EACE,kBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,iBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;AAXF;;AAaA;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;AAVF;;AAaE;EACE,8BAAA;EACA,0BAAA;AAVJ;;AAaA;EACE,kCAAA;AAVF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.choose-date {\r\n  margin-top: 15px;\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n  margin: 10px auto;\r\n}\r\n\r\n.lower-right-button {\r\n  position: absolute;\r\n  bottom: 0;\r\n\r\n  right: 1%;\r\n}\r\n\r\n.separator {\r\n  height: 15px;\r\n}\r\n\r\n.modal-content {\r\n  padding: 15px;\r\n\r\n  .div-see {\r\n    overflow-y: auto;\r\n\r\n    .card {\r\n      width: 100%;\r\n      margin: 10px auto;\r\n\r\n      .id {\r\n        color: rgb(173, 173, 173);\r\n        font-style: italic;\r\n      }\r\n    }\r\n  }\r\n\r\n  .non_inherited {\r\n    color: #8bb7f0;\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  margin: 30px auto;\r\n  margin-bottom: 50px;\r\n  width: 100%;\r\n  max-width: 120px;\r\n  border-radius: 5px;\r\n  background: #fff;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 25px;\r\n  position: relative;\r\n}\r\n\r\n.wrapper h3,\r\n.wrapper p {\r\n  font-family: \"Neucha\", cursive;\r\n  padding: 10px;\r\n  border-radius: 5px 0 0 5px;\r\n  font-size: 18px;\r\n  color: #333;\r\n}\r\n\r\n.plus {\r\n  right: -20px;\r\n  color: #538ae4;\r\n}\r\n\r\n.minus {\r\n  cursor: pointer;\r\n}\r\n\r\n.button-add-users {\r\n  //background-color: #305a8e;\r\n  //color: white;\r\n}\r\n\r\n.group {\r\n  position: relative;\r\n  margin-bottom: 45px;\r\n}\r\n\r\n.sub-title {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.bloc-document {\r\n  border-radius: 5px;\r\n  background-color: #e3e3e3;\r\n  padding: 5px 10px;\r\n  margin: 10px 0;\r\n}\r\n.bloc-documenthide {\r\n  border-radius: 5px;\r\n  background-color: #777777;\r\n  padding: 5px 10px;\r\n  margin: 10px 0;\r\n}\r\n::ng-deep .myTooltip {\r\n  .mdc-tooltip__surface {\r\n    background: #ecac54 !important;\r\n    font-size: 1rem !important;\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
